import Image from 'next/image'
import type { StaticImageData } from 'next/image'
import Trans from 'next-translate/Trans'
import * as RadixPopover from '@radix-ui/react-popover'
import { Popover } from 'components/Popover'
import { Icon } from 'components/Icon'
import {
  PopTrigger,
  PopoverCard,
  PopoverCardHeader,
  PopoverCardClose,
  PopoverCardImage,
  PopoverCardBody,
  PopoverCardHeading,
  PopoverCardText,
} from './InfoCard.styles'

type InfoCardProps = {
  heading: string
  body: string
  image: StaticImageData
  imageAlt: string
  children?: React.ReactNode
  triggerColor?: 'black'
  variant?: 'liveBetter' | 'realResults'
}

export const InfoCard = ({ heading, body, image, imageAlt, children, triggerColor, variant }: InfoCardProps) => (
  <Popover trigger={<PopTrigger color={triggerColor}>{children}</PopTrigger>} side="bottom" hideOutline>
    <PopoverCard>
      <PopoverCardHeader>
        <RadixPopover.Close asChild>
          <PopoverCardClose aria-label="Close">
            <Icon name="close-line" size="3" />
          </PopoverCardClose>
        </RadixPopover.Close>
      </PopoverCardHeader>
      <PopoverCardImage variant={variant}>
        <Image layout="fill" objectFit="cover" src={image} alt={imageAlt} />
      </PopoverCardImage>
      <PopoverCardBody>
        <PopoverCardHeading weight="semiBold">{heading}</PopoverCardHeading>
        <PopoverCardText>
          <Trans i18nKey={body} components={{ bold: <strong /> }} />
        </PopoverCardText>
      </PopoverCardBody>
    </PopoverCard>
  </Popover>
)
